import { render } from "./IndexByPaket.vue?vue&type=template&id=f231bf64"
import script from "./IndexByPaket.vue?vue&type=script&lang=js"
export * from "./IndexByPaket.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__